import React, { useState } from 'react'
import { Button, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { COLORS } from 'src/utils/Themes/colors'
import reportsBg from 'src/assets/RiskReport_images/reports.svg'
import Modal from 'src/components/common/Modal'
import ViewDownloadReportFiles from 'src/components/RiskCategories/components/ViewDownloadReportFiles'

const DownloadReports = ({
  title,
  desc,
  text,
  disabled,
  downloadReportData,
}) => {
  const classes = useStyles()
  const [viewUploadedFiles, setViewUploadedFiles] = useState(false)
  const closeViewUploadedFiles = () => {
    setViewUploadedFiles(false)
  }

  return (
    <>
      {viewUploadedFiles ? (
        <>
          <Modal
            bgcolor={'#FFFFFF'}
            ordered={viewUploadedFiles}
            width={'60%'}
            left={'20%'}
            top={'5%'}
            modelClosed={closeViewUploadedFiles}
            class={classes.modalRoot}
          >
            <div className={classes.modalContent}>
              <ViewDownloadReportFiles
                category={false}
                closeModal={closeViewUploadedFiles}
                downloadReportData={downloadReportData}
              />
            </div>
          </Modal>
        </>
      ) : null}

      <div className={classes.card}>
        <div className={classes.cardbg}>
          <h2 className={classes.title}>{title}</h2>
          <Typography className={classes.desc}>{desc}</Typography>

          <Button
            id='download-button'
            variant='contained'
            classes={{ root: classes.btn }}
            disabled={disabled}
            onClick={() => {
              setViewUploadedFiles(true)
            }}
          >
            {text}
          </Button>
        </div>
      </div>
    </>
  )
}

export default DownloadReports

const useStyles = makeStyles({
  card: {
    width: '100%',
    background: `linear-gradient(273.71deg, ${COLORS.WHITE} -108.2%, ${COLORS.DARK_PINK} 90.01%)`,
    boxSizing: 'border-box',
    color: COLORS.WHITE,
    borderRadius: '10px',
    padding: '24px 0px 0px 0px',
  },
  cardbg: {
    backgroundImage: `url(${reportsBg})`,
    backgroundRepeat: 'no-repeat',
    width: '100%',
    minHeight: 'inherit',
    backgroundPosition: '90% 0px',
    boxSizing: 'border-box',
    padding: '0px 24px 50px 24px',
    paddingRight: '130px',
  },
  title: {
    fontSize: '18px',
    lineHeight: '24px',
    marginTop: '0px',
  },
  desc: {
    fontSize: '14px',
    lineHeight: '18px',
    marginTop: '0px',
    marginBottom: '50px',
  },
  btn: {
    backgroundColor: COLORS.WHITE,
    color: COLORS.DARK_PINK,
    borderRadius: '60px',
    padding: '2px 12px',
    fontSize: '12px',
    width: 'max-content',
    textTransform: 'capitalize',
    '&:hover': {
      backgroundColor: COLORS.WHITE,
    },
  },
  modalContent: {
    textAlign: 'center',
    padding: '24px',
    height: 'calc(100% - 48px)',
    overflow: 'auto',
  },
  modalRoot: {
    height: '90%',
  },
})
